const updateCategoriesLoading = (state, { payload: { loading } }) => {
	state.loading = loading;
};

export default updateCategoriesLoading;
